module.exports = __webpack_public_path__ + "img/start-charging-mobile.93fe3694.png";